import { StyleSheet } from 'aphrodite';
import { brandPrimary, success, white } from '../../../../styles/colors';
import { TRANSITIONS } from '../../styles/baseStyles';

export const styleSheet = StyleSheet.create({
	panelOverlay: {
		margin: 0,
		padding: 0,
		pointerEvents: 'none',
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		overflow: 'visible',
		zIndex: 10,
	},

	transformContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: 0,
		height: 0,
		overflow: 'visible',
	},

	dragGhost: {
		position: 'absolute',
		border: `2px dashed ${brandPrimary}`,
		borderRadius: 8,
		background: `${brandPrimary}10`,
		transition: `border-color ${TRANSITIONS.FAST} ease, background ${TRANSITIONS.FAST} ease`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	dragGhostValid: {
		borderColor: success,
		background: `${success}15`,
	},

	ghostLabel: {
		background: white,
		padding: '4px 12px',
		borderRadius: 4,
		fontSize: 12,
		fontWeight: 600,
		color: brandPrimary,
		boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
	},

	dropZoneIndicator: {
		position: 'absolute',
		display: 'flex',
		alignItems: 'center',
		width: 200,
		height: 4,
	},

	dropZoneBranch: {
		// Additional styling for branch drops
	},

	dropZoneLine: {
		flex: 1,
		height: 2,
		background: success,
	},

	dropZoneCircle: {
		width: 12,
		height: 12,
		borderRadius: '50%',
		background: success,
		border: `2px solid ${white}`,
		boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
	},

	branchLabel: {
		position: 'absolute',
		top: -20,
		left: '50%',
		transform: 'translateX(-50%)',
		background: success,
		color: white,
		padding: '2px 8px',
		borderRadius: 4,
		fontSize: 10,
		fontWeight: 600,
		whiteSpace: 'nowrap',
	},
});
